import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { State } from "@progress/kendo-data-query";

import { AsyncJob } from '../../models/async-job.model';
import { AsyncJobService } from '../../services/async-job.service';
import { ExportDataService } from '../../services/export-data.service';
import { ExportAsyncJobDialogBase } from '../async-job-base/export-async-job-base.dialog';
//import { ExportFormInstancesMetrics } from '../../models/export-import/export-form-instances-metrics.model';
import { GenericExportDataAsExcelSpreadsheet, ExportDataServiceNames } from '../../models/export-import/generic-export-data-as-excel-spreadsheet';

export enum ExportDataDialogAction {
    ExportGridData = 'ExportGridData',
    ExportFormInstance = 'ExportFormInstance',
    ExportTemplateInstances = 'ExportTemplateInstances'
}

export class ExportDataDialogConfig {
    public action: ExportDataDialogAction;
    public objectId: number; // The id of the object being exported.
    public parameterObject: object; // Provides an untyped means of pasing a parameter to this dialogue, not an elegant mechanism but serviceable.
    public formInstanceIds: number[];
    public allFormsSelected: boolean = false;
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// PJH - 8/7/2024
// Although this dialog is coded to support multiple use cases, I don't see any actual uses of it besides FormTemplateInstancesComponent
// There is a reference to it in StructureComponent.doOnExportStructureInstance() but that method does not appear to be called from anywhere
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

@Component({
    selector: 'app-export-data',
    templateUrl: './export-data.dialog.html',
    styleUrls: [
        '../async-job-base/async-job-base.dialog.scss',
        './export-data.dialog.scss'
    ],
    standalone: false
})
export class ExportDataDialog extends ExportAsyncJobDialogBase implements OnInit {
    // Properties.

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ExportDataDialog>,
        @Inject(MAT_DIALOG_DATA) public config: ExportDataDialogConfig,
        private exportDataService: ExportDataService,
        protected injectedAsyncJobService: AsyncJobService) {
        super(injectedAsyncJobService);
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'ExportDataDialog';
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    // Accessor methods.
    public get Title(): string {
        let title: string = null;

        if (this.config.action == ExportDataDialogAction.ExportGridData)
            title = 'Export Grid Data';
        else if (this.config.action == ExportDataDialogAction.ExportFormInstance)
            title = 'Export Form';
        else if (this.config.action == ExportDataDialogAction.ExportTemplateInstances)
            title = 'Export Forms';

        return title;
    }

    public get ExportStructureName(): string {
        let name: string = null;

        if (this.config.action == ExportDataDialogAction.ExportGridData)
            name = 'Grid Data';
        else if (this.config.action == ExportDataDialogAction.ExportFormInstance)
            name = 'Form';
        else if (this.config.action == ExportDataDialogAction.ExportTemplateInstances)
            name = 'Form';

        return name;
    }
    public get ExportDescription(): string {
        let description: string = null;

        if (this.config.action == ExportDataDialogAction.ExportGridData)
            description = 'Grid data will export as an Excel spreadsheet.';
        else if (this.config.action == ExportDataDialogAction.ExportFormInstance)
            description = 'Export a single form';
        else if (this.config.action == ExportDataDialogAction.ExportTemplateInstances)
            description = 'Export form data';

        return description;
    }

    // Handle dialogue action(s).
    public startStructureExport(): void {
        if (this.config.action == ExportDataDialogAction.ExportGridData) {
            this.exportDataService.exportGridDataAsExcelSpreadsheet(this.config.objectId).then(asyncJob => {
                this.startMonitoringJob(asyncJob, this.jobUpdatedArrowFunction);
            });
        } else if (this.config.action == ExportDataDialogAction.ExportFormInstance) {
            this.exportDataService.exportFormInstance(this.config.objectId).then(formInstance => {
                console.log('ExportDataDialog():  retrieved a form instance.');
            });
        } else if (this.config.action == ExportDataDialogAction.ExportTemplateInstances) {
            let formFieldId: number = this.config.objectId;
            let exportInstructions: GenericExportDataAsExcelSpreadsheet =
                new GenericExportDataAsExcelSpreadsheet(formFieldId, ExportDataServiceNames.FormTemplateInstancesService, this.config.formInstanceIds, this.config.allFormsSelected);
            console.log(exportInstructions);
            exportInstructions.gridState = <State>this.config.parameterObject;
            this.exportDataService.genericExportDataAsExcelSpreadsheet(exportInstructions).then(asyncJob => {
                this.startMonitoringJob(asyncJob, this.jobUpdatedArrowFunction);
            });
        }
    }

    // Private methods.
    private jobUpdatedArrowFunction = (asyncJob: AsyncJob): void => {
        // Ask the copy site service to download the
        // exported site(in a separate browser tab).
        if (asyncJob.status == AsyncJob.STATUS_COMPLETE) {
            let downloadFileName: string = null;
            if (this.config.action == ExportDataDialogAction.ExportGridData) {
                downloadFileName = `grid_${this.config.objectId}_data.xlsx`;
            } else if (this.config.action == ExportDataDialogAction.ExportTemplateInstances) {
                downloadFileName = `template_${this.config.objectId}_form_data.xlsx`;
            }

            this.ExportedDataUrl = this.exportDataService.getResultFileDownloadUrl(asyncJob, downloadFileName);
        }

        return;
    }
}
